import AxiosInstance from "./api";
import { map } from "rxjs";

export function createAccount (email, password, firstName, lastName, requestAssuranceRole) {
  const data = JSON.stringify({ email, password, firstName, lastName, requestAssuranceRole });
  return AxiosInstance.post('api/v1/user', data).pipe(
    map(res => res.data.data.user)
  );
}

export function authenticate (email, password, rememberMe, totpCode) {
  const data = JSON.stringify({ email, password, rememberMe, dtv: true, totpCode  });
  return AxiosInstance.post('api/v1/user/token', data);
}

export function logout () {
  return AxiosInstance.delete('api/v1/user/token');
}

export function getCurrentUser () {
  return AxiosInstance.get('api/v1/user').pipe(
    map(res => res.data.data.user)
  );
}

export function getRoles () {
  return AxiosInstance.get('api/v1/user/role').pipe(
    map(res => res.data.data)
  );
}

export function getMFASetup () {
  return AxiosInstance.get('api/v1/user/mfa').pipe(
    map(res => res.data.data)
  );
}

export function verifyMFASetup (totpCode, totpSecret) {
  const data = JSON.stringify({ totpCode, totpSecret });
  return AxiosInstance.post('api/v1/user/mfa', data).pipe(
    map(res => res.data.data)
  );
}
